import CompanyLogo from "../img/header_logo.png";
import React, {
  useState,
  useEffect,
  useMemo,
  Fragment,
  useCallback,
} from "react";
import { useTranslation } from "react-i18next";
import Icon from "./ui/Icon";
import LanguageSelector from "./LanguageSelector";
import {
  AppBar,
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Toolbar,
} from "@mui/material";
import functionConstants from "../utils/functionConstants";
import { LoginService } from "../services/loginService";

const PlusNavbar = () => {
  const { t } = useTranslation();
  const username = localStorage.getItem("name");
  const functionId = localStorage.getItem("functionId");
  const functionList = String(functionId).split(",");
  const [anchorCMS, setAnchorCMS] = useState(null);
  const [anchorUser, setAnchorUser] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [drawerContainer, setDrawerContainer] = useState(null);

  const openCMS = Boolean(anchorCMS);
  const openUser = Boolean(anchorUser);

  const handleDrawerToggle = useCallback(
    () => setMobileOpen((prevState) => !prevState),
    []
  );

  const onLogout = useCallback(() => {
    localStorage.clear();
    var loginService = new LoginService();
    loginService.logout();
    window.location = "/login";
  }, []);

  const quickLinkRole = useMemo(() => {
    return functionList.includes(String(functionConstants.CMS_QUICK_LINKS_ADD));
  }, [functionList]);

  const eventCalendarRole = useMemo(() => {
    return functionList.includes(
      String(functionConstants.CMS_EVENT_CALENDAR_ADD)
    );
  }, [functionList]);

  const categoryRole = useMemo(() => {
    return functionList.includes(String(functionConstants.CMS_CATEGORIES_ADD));
  }, [functionList]);

  const brokerComRole = useMemo(() => {
    return functionList.includes(
      String(functionConstants.CMS_BROKER_COMMUNICATION_ADD)
    );
  }, [functionList]);

  const CMSRole = useMemo(() => {
    return quickLinkRole || eventCalendarRole || categoryRole || brokerComRole;
  }, [quickLinkRole, eventCalendarRole, categoryRole, brokerComRole]);

  const DOCRole = useMemo(() => {
    return functionList.includes(
      String(functionConstants.DOCUMENT_CENTER_VIEW)
    );
  }, [functionList]);

  const CampaignRole = useMemo(() => {
    return (
      functionList.includes(
        String(functionConstants.CAMPAIGN_HEADER_BDELIGHT_VIEW)
      ) ||
      functionList.includes(
        String(functionConstants.CAMPAIGN_HEADER_CICONV_VIEW)
      ) ||
      functionList.includes(
        String(functionConstants.CAMPAIGN_HEADER_KDOLLAR_VIEW)
      )
    );
  }, [functionList]);

  const navItems = useMemo(
    () => [
      {
        label: "nav.cms",
        permission: CMSRole,
        link: [
          {
            label: "nav.cms.brokersCommunications",
            permission: brokerComRole,
            link: "/BrokerCom",
          },
          {
            label: "nav.cms.categories",
            permission: categoryRole,
            link: "/Categories",
          },
          {
            label: "nav.cms.eventCal",
            permission: eventCalendarRole,
            link: "/EventCalendar",
          },
          {
            label: "nav.cms.quickLinks",
            permission: quickLinkRole,
            link: "/QuickLinks",
          },
        ],
      },
      { label: "nav.campaign", permission: CampaignRole, link: "/Campaign" },
      { label: "nav.docCenter", permission: DOCRole, link: "/DocCenter" },
    ],
    [
      CMSRole,
      CampaignRole,
      DOCRole,
      brokerComRole,
      categoryRole,
      eventCalendarRole,
      quickLinkRole,
    ]
  );

  useEffect(() => {
    //console.log(document.querySelectorAll("#pageLogin"));
    if (document.querySelectorAll("#pageLogin").length > 0) {
      //if (window !== undefined && window.location.pathname === "/login") {
      document.querySelectorAll("#navbar")[0].style.display = "none";
    }
    if (document !== undefined) {
      setDrawerContainer(document.querySelector("body"));
    }
  }, []);

  return (
    <Box id="navbar">
      <AppBar component="nav" sx={{ bgcolor: "white", position: "relative" }}>
        <Toolbar sx={{ my: 1, maxWidth: 1350, m: "auto", width: "90%" }}>
          <Box
            component="button"
            onClick={() =>
              (window.location =
                localStorage.getItem("ifa") === "null" &&
                functionList.includes(
                  String(functionConstants.DOCUMENT_CENTER_VIEW)
                )
                  ? "/"
                  : localStorage.getItem("ifa") === "COMMON"
                  ? "/DocCenter"
                  : "/Campaign")
            }>
            <Box
              component="img"
              src={CompanyLogo}
              alt=""
              className=""
              sx={{ height: 30 }}
            />
          </Box>

          {/* nav list */}
          <Box
            sx={{ flexGrow: 1, mx: 2, display: { xs: "none", lg: "block" } }}>
            {navItems.map((item, index) =>
              item.permission && Array.isArray(item.link) ? (
                <Fragment key={index}>
                  <Button
                    id="cms-button"
                    aria-controls={openCMS ? "cms-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={openCMS ? "true" : undefined}
                    onClick={(e) => setAnchorCMS(e.currentTarget)}
                    endIcon={<Icon src="arrowDrop" color="#000" />}
                    sx={{
                      color: "#000",
                      borderBottom: "3px solid transparent",
                    }}>
                    {t(item.label)}
                  </Button>
                  <Menu
                    id="cms-menu"
                    aria-labelledby="cms-button"
                    anchorEl={anchorCMS}
                    open={openCMS}
                    onClose={() => setAnchorCMS(null)}>
                    {item.link.map(
                      (subItem, index) =>
                        subItem.permission && (
                          <MenuItem
                            key={index}
                            onClick={() => (window.location = subItem.link)}>
                            {t(subItem.label)}
                          </MenuItem>
                        )
                    )}
                  </Menu>
                </Fragment>
              ) : (
                item.permission && (
                  <Button
                    key={index}
                    onClick={() => (window.location = item.link)}
                    sx={{
                      color: "#000",
                      borderRadius: 0,
                      borderBottom: "3px solid transparent",
                      transition: "all .3s",
                      "&:hover": {
                        borderBottom: "3px solid #009188",
                      },
                    }}>
                    {t(item.label)}
                  </Button>
                )
              )
            )}
          </Box>

          {/* language and user */}
          <Box sx={{ display: { xs: "none", lg: "flex" } }}>
            <LanguageSelector type="dropdown" />

            <Divider
              orientation="vertical"
              flexItem
              sx={{ border: "1px solid #000", my: 1 }}
            />

            <Button
              id="user-button"
              aria-controls={openUser ? "user-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openUser ? "true" : undefined}
              onClick={(e) => setAnchorUser(e.currentTarget)}
              startIcon={
                <Icon src="person" color="text.primary" sx={{ ml: 1 }} />
              }
              sx={{ color: "#000" }}>
              {username}
            </Button>
            <Menu
              id="user-menu"
              aria-labelledby="user-button"
              anchorEl={anchorUser}
              open={openUser}
              onClose={() => setAnchorUser(null)}>
              <MenuItem onClick={onLogout}>{t("nav.logout")}</MenuItem>
            </Menu>
          </Box>

          {/* mobile menu button */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "flex", lg: "none" },
              justifyContent: "flex-end",
            }}>
            <IconButton onClick={handleDrawerToggle}>
              <Icon src="menu" color="#000" htmlColor="#000" />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      <Box component="nav">
        <Drawer
          container={drawerContainer}
          variant="temporary"
          anchor="top"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", lg: "none" },
            "& .MuiDrawer-paper": { boxSizing: "border-box" },
          }}>
          <Box onClick={handleDrawerToggle} sx={{ textAlign: "center", my: 3 }}>
            <Box
              component="button"
              onClick={() =>
                (window.location =
                  localStorage.getItem("ifa") === "null" &&
                  functionList.includes(
                    String(functionConstants.DOCUMENT_CENTER_VIEW)
                  )
                    ? "/"
                    : localStorage.getItem("ifa") === "COMMON"
                    ? "/DocCenter"
                    : "/Campaign")
              }>
              <Box
                component="img"
                src={CompanyLogo}
                alt="CTFLife"
                sx={{ height: 25 }}
              />
            </Box>

            <Stack alignItems="flex-start">
              {navItems.map((item, index) =>
                Array.isArray(item.link)
                  ? item.permission && (
                      <Fragment key={index}>
                        <Button
                          color="inherit"
                          sx={{ justifyContent: "flex-start" }}>
                          {t(item.label)}
                        </Button>
                        <Stack alignItems="flex-start">
                          {item.link.map((subItem, index) => (
                            <Button
                              key={index}
                              onClick={() => (window.location = subItem.link)}
                              sx={{ ml: 4, justifyContent: "flex-start" }}
                              color="inherit">
                              {t(subItem.label)}
                            </Button>
                          ))}
                        </Stack>
                      </Fragment>
                    )
                  : item.permission && (
                      <Button
                        key={index}
                        onClick={() => (window.location = item.link)}
                        sx={{ justifyContent: "flex-start" }}
                        color="inherit">
                        {t(item.label)}
                      </Button>
                    )
              )}
              <Button
                onClick={onLogout}
                color="inherit"
                sx={{ justifyContent: "flex-start" }}>
                {t("nav.logout")}
              </Button>
            </Stack>

            <LanguageSelector option="button" />
          </Box>
        </Drawer>
      </Box>
    </Box>
  );
};

export default PlusNavbar;
